"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoveConvictionCommand = void 0;
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var RemoveConvictionCommand = /** @class */ (function (_super) {
    __extends(RemoveConvictionCommand, _super);
    function RemoveConvictionCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RemoveConvictionCommand.prototype.exec = function (props) {
        var driverIndex = this.getSetting("driverIndex", props.journeyEventDefinition.settings);
        var index = this.getSetting("index", props.journeyEventDefinition.settings);
        var parentObject = driverIndex === undefined ? props.interaction.policyHolder : props.interaction.additionalDrivers[driverIndex];
        var parentObjectString = driverIndex === undefined ? "policyHolder" : "additionalDrivers[".concat(driverIndex, "]");
        var convictions = parentObject.convictions;
        if (convictions.length > 1) {
            convictions.splice(index, 1);
        }
        else {
            convictions = [];
        }
        props.updateInteraction(convictions, "".concat(parentObjectString, ".convictions"));
        props.updateInteraction(convictions.length, "".concat(parentObjectString, ".numberOfConvictions"));
        props.updateInteraction(convictions.length > 0, "".concat(parentObjectString, ".hasConvictions"));
        return Promise.resolve({});
    };
    return RemoveConvictionCommand;
}(plugin_journey_1.JourneyCommandBase));
exports.RemoveConvictionCommand = RemoveConvictionCommand;
//# sourceMappingURL=RemoveConvictionCommand.js.map